<template>
	<div>
		<div style="position: relative;">
			<router-view></router-view>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'App',
		data(){
			return {
				
			}
		},
		methods:{
			
			
		},
		mounted() {
		  // 获取 DOM 元素
			
		}
	}
</script>

<style>
	
	
	*{
		margin: 0;
		padding: 0;
		
	}
	.swiper-slide{
		transform: scale(0.8);
	}
	.swiper-slide-active{
		transform: scale(1);
	}
	.video-js button{
		outline: none !important;
	}
	.video-js .vjs-big-play-button{
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
	}
</style>
